const simulatedReader = {
  device_type: 'verifone_P400',
  id: 'SIMULATOR',
  label: 'Reader Simulator',
  livemode: false,
  location: 'st_simulated',
  object: 'terminal.reader',
  serial_number: 'SIMULATOR',
  status: 'online',
}

export const collectPaymentMethod = clientSecret => ({
  paymentIntent: {
    clientSecret,
    id: 'pi_stub',
  },
})

export const connectReader = (selectedReader, { failIfInUse }) => ({
  failIfInUse,
  reader: simulatedReader,
  selectedReader,
})

export const discoverReaders = ({ simulated }) => ({
  discoveredReaders: [simulatedReader],
  simulated,
})

export const processPayment = paymentIntent => ({ paymentIntent })

export const setSimulatorConfiguration = testCardNumber => ({ testCardNumber })
